import { ApiService } from '../ApiService';
import { type DecodedToken } from '../types';
import { type Game, type ScoreResponse } from './types';

export const getGame = async (decodedToken: DecodedToken): Promise<Game> => {
  const { gameKey } = decodedToken;

  const { data } = await ApiService.instance.get(`v1/games/key/${gameKey}`);

  return data;
};

interface GameDataPayload {
  progress?: Record<string, unknown>;
  achievements?: unknown[];
}

// External games may post progress in any shape. The API contract expects
// data wrapped into { progress: {...} } and/or { achievements: [...] }.
const normalizeGameProgress = (data: unknown): GameDataPayload => {
  if (!data || typeof data !== 'object') return {};

  const input = data as Record<string, unknown>;
  const hasProgress = !!input.progress && typeof input.progress === 'object';
  const hasAchievements = Array.isArray(input.achievements);

  if (hasProgress || hasAchievements) {
    const result: GameDataPayload = {};
    if (hasProgress) result.progress = input.progress as Record<string, unknown>;
    if (hasAchievements) result.achievements = input.achievements as unknown[];
    return result;
  }

  return { progress: input };
};

export const sendGameProgress = async (data: unknown): Promise<any> => {
  //TODO: if there are more methods for this endpoint, then it's worth writing something better.
  const url = 'https://playdeck-gamer.playdeck.io/api/v1/game/data';
  const payload = normalizeGameProgress(data);
  const response = await ApiService.instance.request({ method: 'PUT', url, data: payload });
  return response?.data;
};

export const getScore = async (): Promise<ScoreResponse> => {
  const response = await ApiService.instance.get('game/v1/score');
  return await response?.data;
};

export const setScore = async (score: number): Promise<void> => {
  await ApiService.instance.post('game/v1/score', { score });
};

export const reportUser = async (userId: number): Promise<void> => {
  await ApiService.instance.post(`v1/fights/report/${userId}`);
};
